
const fuseOptions = {
	// isCaseSensitive: false,
	// includeScore: false,
	// shouldSort: true,
	// includeMatches: false,
	findAllMatches: true,
	minMatchCharLength: 3,
	// location: 0,
	threshold: 0.5,
	// distance: 100,
	useExtendedSearch: true,
	// ignoreLocation: false,
	// ignoreFieldNorm: false,
	// fieldNormWeight: 1,
	keys: [
		"AirportCode","ISOCountryCode","AirportName","Country"
	]
};

const fuse = new Fuse(lounge_info, fuseOptions);
var results = [];
var temp_airport_id = -1;
var temp_airport_lounges = [];
var temp_airport_lounges_by_airport = [];
var airport_lounges = [];
var current_slider_interval;
const facities_list = [
  "tel", "refreshments", "television", "newsmag", "showers", "internt", "conf", "wifi", "alcohol", "fax", "aircon", "flightinformonitor", "disabledaccess", "nosmoking"]

$('#search-bar').on('keyup keypress', function(e) {
  var keyCode = e.keyCode || e.which;
  if (keyCode === 13) { 
    e.preventDefault();
    return false;
  }
}).on('keyup', function () {
  searchKeyUpHandler($(this), $(this).closest('div.lounge-search-page').find('.search-dropdown'))
});

$('#top-search-bar').on('keyup keypress', function(e) {
  var keyCode = e.keyCode || e.which;
  if (keyCode === 13) { 
    e.preventDefault();
    return false;
  }
}).on('keyup', function () {
  searchKeyUpHandler($(this), $(this).closest('div.lounge-details-page').find('.top-search-dropdown'))
});

$('body')
  .on('mouseover', '.search-dropdown .airport', function() {
    $(this).addClass('hover');
  })
  .on('mouseover', '.top-search-dropdown .airport', function() {
    $(this).addClass('hover');
  })
  .on('mouseout', '.search-dropdown .airport', function() {
    $(this).removeClass('hover');
  })
  .on('mouseout', '.top-search-dropdown .airport', function() {
    $(this).removeClass('hover');
  })
  .on('click', '.search-dropdown .airport', function() {
    airport_lounges = temp_airport_lounges;
    $('.lounge-search-page').hide();
    displaySearchResult($(this).data('airport-id'));
  })
  .on('click', '.top-search-dropdown .airport', function() {
    airport_lounges = temp_airport_lounges;
    $('.top-search-dropdown').hide();
    $('.search-dropdown').hide();
    $('.lounge-search-page').hide();
    displaySearchResult($(this).data('airport-id'));
  });

$('body')
  .on('click', '.lounge-sidebar .lounge-list a', function(e) {
    e.preventDefault();
    $('.lounge-sidebar .lounge-terminal details ul.lounge-list li a').removeClass('active');
    $(this).addClass('active');
    displayLoungeDetail(airport_lounges[$(this).data('airport-id')][$(this).data('lounge-id')]);
  });

function searchKeyUpHandler($searchBar, $searchDropdown) {
  temp_airport_id = -1;
  temp_airport_lounges = [];
  temp_airport_lounges_by_airport = [];
  
  var keyword = $searchBar.val();
  if (keyword.length >= 3) {
    $searchDropdown.html("");
    results = fuse.search("'" + keyword);

    if (results.length > 0) {
      results = results.sort((a, b) => {
        if (a.item.Country < b.item.Country) {
          return -1;
        }
      });

      var current_country = "";
      var current_airport = "";
      var temp_html = "";
      
      for (var i=0; i < results.length; i++) {
        if (current_country !== results[i].item.Country) {
          current_country = results[i].item.Country;

          if (temp_html !== "") {
            temp_html = temp_html + `
            </div>
            <div class="search-dropdown-item">
            `;
          } else {
            temp_html = temp_html + `
            <div class="search-dropdown-item">
            `;
          }

          temp_html = temp_html + `
            <div class="city">` + results[i].item.Country + ` (` + results[i].item.ISOCountryCode + `)</div>
          `;
        }

        if (current_airport !== results[i].item.AirportName) {
          temp_airport_id = temp_airport_id + 1;
          if (temp_airport_lounges_by_airport.length > 0) {
            temp_airport_lounges.push(temp_airport_lounges_by_airport);
          }
          temp_airport_lounges_by_airport = [];
          current_airport = results[i].item.AirportName;

          temp_html = temp_html + `
            <div class="airport" data-airport-id="` + temp_airport_id + `">` + results[i].item.AirportName + ` (` + results[i].item.AirportCode + `)</div>
          `;
        }

        temp_airport_lounges_by_airport.push(results[i]);

        if (i == (results.length - 1)) {
          temp_airport_lounges.push(temp_airport_lounges_by_airport);
        }
      }
      temp_html = temp_html + `</div>`;
      $searchDropdown.append(temp_html).show();
    } else {
      var temp_html = "";
      temp_html = temp_html + `
        <div class="search-dropdown-item">
          <div class="city">` + error_msg['no_match_lounge'] + `</div>
        </div>
      `;
      $searchDropdown.append(temp_html).show();
    }
  } else {
    $searchDropdown.html("").hide();
           
            
  }
}

function displaySearchResult(selected_airport_id) {
  $('.lounge-sidebar').html('');
  if (airport_lounges[selected_airport_id].length > 0) {
    airport_lounges[selected_airport_id] = airport_lounges[selected_airport_id].sort((a, b) => {
      if (a.item.CGTerminal < b.item.CGTerminal) {
        return -1;
      }
    });

    // GENERATE THE SIDEBAR
    var current_terminal = "";
    var temp_sidebar_html = "";

    for (var i = 0; i < airport_lounges[selected_airport_id].length; i++) {
      if (current_terminal !== airport_lounges[selected_airport_id][i].item.CGTerminal || airport_lounges[selected_airport_id][i].item.CGTerminal == "") {
        current_terminal = airport_lounges[selected_airport_id][i].item.CGTerminal;
        if (temp_sidebar_html !== "") {
          temp_sidebar_html = temp_sidebar_html + `
                </ul>
              </div>
            </details>
          </div>
          `;
        }

        if (airport_lounges[selected_airport_id][i].item.CGTerminal == "") {
          var display_terminal_name = airport_lounges[selected_airport_id][i].item.AirportName;
        } else {
          var display_terminal_name = airport_lounges[selected_airport_id][i].item.CGTerminal;
        }

        temp_sidebar_html = temp_sidebar_html + `
          <div class="lounge-terminal accordion">
            <details id="">
              <summary id="" class="accordion-item" role="button" aria-expanded="false" aria-controls="lounge-terminal-2">
                  <h3 class="terminal-name h3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 30 24">
                      <path id="Icon_material-outline-airplane-ticket" data-name="Icon material-outline-airplane-ticket" d="M30.285,6H6A3,3,0,0,0,3.015,9v6A3,3,0,0,1,3,21v6a3.009,3.009,0,0,0,3,3H30a3.009,3.009,0,0,0,3-3V9A2.872,2.872,0,0,0,30.285,6ZM30,27H6V23.19A6.02,6.02,0,0,0,9,18a5.988,5.988,0,0,0-2.985-5.19L6,9H30ZM13.305,23.49l-2.49-4.32,1.4-.375L14.1,20.28l3.585-.96-3.6-6.24,2.1-.57L22.2,18.12l3.66-.975a1.451,1.451,0,0,1,1.77,1.02,1.482,1.482,0,0,1-1.035,1.785l-13.29,3.54Z" transform="translate(-3 -6)"/></path>
                    </svg>                              
                    <span>` + display_terminal_name + `</span>
                  </h3>
                  <svg class="accordion-arrow" xmlns="http://www.w3.org/2000/svg" width="18" height="10.8" viewBox="0 0 18 10.8">
                    <path id="Icon_ion-ios-arrow-left" data-name="Icon ion-ios-arrow-left" d="M10.8,1.091,9.636,0,0,9l9.636,9L10.8,16.914,2.334,9Z" transform="translate(0 10.8) rotate(-90)"/></path>
                  </svg>
                </summary>
                
                <div class="accordion-content rte" id="lounge-terminal-2">
                  <p>` + heading_text['airport_lounges'] + `</p>
                  <ul class="lounge-list">
        `;
      }

      temp_sidebar_html = temp_sidebar_html + `
        <li><a href="#" data-airport-id="` + selected_airport_id + `" data-lounge-id="` + i + `">` + airport_lounges[selected_airport_id][i].item.LoungeName + `</a></li>
      `;
    }

    temp_sidebar_html = temp_sidebar_html + `
                </ul>
              </div>
            </details>
          </div>
    `;

    $('.lounge-sidebar').html(temp_sidebar_html);

    // ACTIVATE THE FIRST LOUNGE IN SIDEBAR
    $('.lounge-sidebar .lounge-terminal:first-child details').attr('open', '');
    $('.lounge-sidebar .lounge-terminal:first-child details ul.lounge-list li:first-child a').addClass('active');

    // UPDATE AIRPORT NAME
    $('.lounge-airport').html(airport_lounges[selected_airport_id][0].item.AirportName);

    // UPDATE LOUNGE DETAIL
    displayLoungeDetail(airport_lounges[selected_airport_id][0]);

    $('.lounge-details-page').show();
  } else {
    // NO RESULT
  }
}

function generateFacilityItem($container, facility_id) {
  $container.append(`
    <li class="facilities-item">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="30" height="30" viewBox="0 0 30 30">
        <image id="` + facility_id + `" data-name="` + facility_id + `" width="30" height="30" xlink:href="` + facilities[facility_id].icon + `" />
      </svg>
      <span>` + facilities[facility_id].name + `</span>
    </li>
  `);
}

function displayLoungeDetail(lounge_detail) {
  $('.lounge-details .lounge-name').html(lounge_detail.item.LoungeName);
  if (lounge_detail.item.CGTerminal !== "") {
    var lounge_location = lounge_detail.item.AirportName + ', ' + lounge_detail.item.CGTerminal;
  } else {
    var lounge_location = lounge_detail.item.AirportName;
  }
  $('.lounge-details .lounge-location').html(lounge_location);

  var temp_image_image = "";
  $('.lounge-slider .dots').html("");
  for (var i = 0; i < lounge_detail.item.Images.length; i++) {
    temp_image_image = temp_image_image + `
      <div class="slide"><img src="` + lounge_detail.item.Images[i].Url + `" alt="` + lounge_detail.item.Images[i].AltText + `"></div>
    `;
  }
  $('.lounge-slider .slides').html(temp_image_image);
  
  activateSlider();
  
  

  $('.lounge-info-body').html("");

  if (lounge_detail.item.OpeningHours !== "") {
    $('.lounge-info-body').append('<h2>' + heading_text['opening_hours'] + '</h2>').append('<p>' + lounge_detail.item.OpeningHours + '</p>');
  }

  if (lounge_detail.item.Location !== "") {
    $('.lounge-info-body').append('<h2>' + heading_text['location'] + '</h2>').append('<p>' + lounge_detail.item.Location + '</p>');
  }

  if (lounge_detail.item.Conditions !== "") {
    $('.lounge-info-body').append('<h2>' + heading_text['conditions'] + '</h2>').append('<p>' + lounge_detail.item.Conditions + '</p>');
  }

  if (lounge_detail.item.Additional !== "") {
    $('.lounge-info-body').append('<h2>' + heading_text['additional_info'] + '</h2>').append('<p>' + lounge_detail.item.Additional + '</p>');
  }
  
  $('.lounge-facilities ul').html("");

  var $loungeFacilitiesContainer = $('.lounge-facilities ul');

  if (lounge_detail.item.Facilities.TEL == true) {
    generateFacilityItem($loungeFacilitiesContainer, "tel");
  }
  
  if (lounge_detail.item.Facilities.REFRESH == true) {
    generateFacilityItem($loungeFacilitiesContainer, "refreshments");
  }
  
  if (lounge_detail.item.Facilities.TV == true) {
    generateFacilityItem($loungeFacilitiesContainer, "television");
  }
  
  if (lounge_detail.item.Facilities.NEWSMAG == true) {
    generateFacilityItem($loungeFacilitiesContainer, "newsmag");
  }
  
  if (lounge_detail.item.Facilities.SHOWER == true) {
    generateFacilityItem($loungeFacilitiesContainer, "showers");
  }
  
  if (lounge_detail.item.Facilities.INTERNT == true) {
    generateFacilityItem($loungeFacilitiesContainer, "internt");
  }
  
  if (lounge_detail.item.Facilities.CONF == true) {
    generateFacilityItem($loungeFacilitiesContainer, "conf");
  }
  
  if (lounge_detail.item.Facilities.WIFI == true) {
    generateFacilityItem($loungeFacilitiesContainer, "wifi");
  }
  
  if (lounge_detail.item.Facilities.ALCOHOL == true) {
    generateFacilityItem($loungeFacilitiesContainer, "alcohol");
  }
  
  if (lounge_detail.item.Facilities.FAX == true) {
    generateFacilityItem($loungeFacilitiesContainer, "fax");
  }
  
  if (lounge_detail.item.Facilities.AIRCON == true) {
    generateFacilityItem($loungeFacilitiesContainer, "aircon");
  }
  
  if (lounge_detail.item.Facilities.FLTINFO == true) {
    generateFacilityItem($loungeFacilitiesContainer, "flightinformonitor");
  }
  
  if (lounge_detail.item.Facilities.DISABLE == true) {
    generateFacilityItem($loungeFacilitiesContainer, "disabledaccess");
  }
  
  if (lounge_detail.item.Facilities.NOSMOKE == true) {
    generateFacilityItem($loungeFacilitiesContainer, "nosmoking");
  }

  

  if ($(window).width() < 990) {
    document.querySelector('.lounge-details').scrollIntoView({
      behavior: 'smooth' 
    });
  } else{
    document.querySelector('.skip-to-content-link').scrollIntoView({
      behavior: 'smooth' 
    });
  }
}


